import { notification } from 'antd';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import OfflineUI from './components/OfflineUI';
import AppUpdatePrompt from './components/AppUpdatePrompt';
import { getPageHeader } from './constants/pageHeaders';
import asyncRoute from './helpers/hoc/asyncRoute';
import routes from './routes';
import { setNavigate } from './utils/navigation';
import { connectSocket } from './utils/socket';

// import Theme from './containers';

const Loader = asyncRoute(() => import('./components/Loader'));
const Theme = asyncRoute(() => import('./containers'));
const Signin = asyncRoute(() => import('./containers/Authentication/Signin'));
const PostSignin = asyncRoute(() => import('./containers/Authentication/PreSignin'));
const SignUpEmail = asyncRoute(() => import('./containers/Authentication/SignUp'));
const CompleteAccount = asyncRoute(() => import('./containers/Authentication/CompleteProfile'));
const AcceptInvitation = asyncRoute(() => import('./containers/Authentication/Invitation'));
const StoreRequest = asyncRoute(() => import('./containers/Authentication/StoreRequest'));

const ConsumerTheme = asyncRoute(() => import('./consumer'));
const ForgotPassword = asyncRoute(() => import('./containers/Authentication/ForgotPassword'));
const ResetPassword = asyncRoute(() => import('./containers/Authentication/ResetPassword'));
// const ConsignorTheme = asyncRoute(() => import("./containers/Consigner/Home/co"));/admin-store-requests
const SuperAdmin = asyncRoute(() => import('./containers-superAdmin/superAdminLanding'));

const App = () => {
    const location = useLocation();
    const Navigate = useNavigate();

    const showSpinner = useSelector((state) => state.app.showFullSpinner);
    // const showSpinner = false;
    // const userRole ="consumer"||isAuthenticated?.role?.roleName.toLowerCase();
    const isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    const userRole = isAuthenticated?.role?.roleName.toLowerCase();
    const PreSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
    const defaultRoute = JSON.parse(localStorage.getItem('defaultMainRoute'));
    const storeSelected = Number(JSON.parse(localStorage.getItem('storeSelected')));
    const [isOnline, setIsOnline] = useState(window.navigator.onLine);

    const [api, contextHolder] = notification.useNotification();
    const openNotificationWithIcon = (type, message) => {
        api.destroy();
        api[type]({
            message,
            // description:
        });
    };

    // THIS IS FOR MAKING DYNAMIC ROUTING WHERE THE USER WILL NOT FALL IN BETWEEN THE ROUTES AND SEE THE PAGE WHERE ROUTE NOT FOUND
    //   const paths = ['/','/onesync', '/onesync/settings/', '/onesync/settings/user', '/onesync/settings/user/'];

    // useEffect(() => {
    //     const currentPath = window.location.pathname;
    //     if (paths.includes(currentPath)) {
    //         Navigate('user/list');
    //     }
    // }, []);

    useEffect(() => {
        connectSocket();

        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    function toTitleCase(str) {
        return (
            str
                ?.split(' ') // Split the string into words
                .map(
                    (
                        word // Map over each word
                    ) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize the first letter and make the rest lowercase
                )
                .join(' ') || 'SignIn'
        ); // Join the words back together with a space
    }
    function handleStore(store) {
        let strName = PreSignInData?.storeList?.map((stoe) => {
            if (stoe.id === store) {
                return stoe.name;
            }
        });

        return strName ? ' - ' + String(strName).replaceAll(',', '') : '';
    }
    useEffect(() => {
        let c = location?.pathname?.split('/') || [];

        const pageHeader = getPageHeader(location.pathname);
        const slug = c[2] === 'home' ? 'dashboard' : String(c[2] || '').replace(/-/g, ' ');
        document.title = `${pageHeader?.title || toTitleCase(slug)}${handleStore(storeSelected)}`;
    }, [location]);

    useEffect(() => {
        const currentUrl = window.location.pathname + window.location.search;
        const publicPaths = ['/forgot-password', '/reset-password', '/signup','/complete-account','/accept-invitation','/admin-store-requests'];

        if (publicPaths.includes(window.location.pathname)) {
            return; // Allow access to public paths
        }

        if (isEmpty(isAuthenticated) && !isEmpty(PreSignInData)) {
            Navigate(`${routes.signIn}`);
        } else if (
            isEmpty(isAuthenticated) ||
            window.location.pathname === '/' ||
            window.location.pathname === `/${routes.mainRoute}` ||
            window.location.pathname === `/${routes.mainRoute}/`
        ) {
            if (currentUrl?.includes('detail')) {
                localStorage.setItem('redirectAfterLogin', currentUrl);
            }
            Navigate(`${routes.preSignIn}`);
        } else {
            // if (checkLoggedInRole(Roles.ADMIN)) {
            //   Navigate(`/${routes.mainRoute}/home`);
            // } else if (checkLoggedInRole(Roles.CONSIGNER)) {
            //   Navigate(`/${routes.mainRoute}/consigner/home`);
            // }
        }
    }, []);
    const navigate = useNavigate();

    React.useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);

    const handleClick = () => {
        setTimeout(() => {
            Navigate(`/${routes.signIn}`);
        }, 500);
    };
    const NotFound = () => {
        if (!isEmpty(isAuthenticated)) {
            handleClick();
        }
    };
    return (
        <>
            {showSpinner && <Loader />}
            {contextHolder}
            <Routes>
                <Route path="/forgot-password" element={<ForgotPassword blue10={''} openNotificationWithIcon={openNotificationWithIcon} />} />
                <Route path="/reset-password" element={<ResetPassword blue10={''} openNotificationWithIcon={openNotificationWithIcon} />} />
                <Route path="/signup" element={<SignUpEmail blue10={''} openNotificationWithIcon={openNotificationWithIcon} />} />
                <Route path="/complete-account" element={<CompleteAccount blue10={''} openNotificationWithIcon={openNotificationWithIcon} />} />
                <Route path="/accept-invitation" element={<AcceptInvitation blue10={''} openNotificationWithIcon={openNotificationWithIcon} />} />
                <Route path="/admin-store-requests" element={<StoreRequest blue10={''} openNotificationWithIcon={openNotificationWithIcon} />} />
                <Route path={`/${routes.preSignIn}`} element={<Signin blue10={''} openNotificationWithIcon={openNotificationWithIcon} />} />
                <Route path={`/${routes.signIn}`} element={<PostSignin blue10={''} openNotificationWithIcon={openNotificationWithIcon} />} />
                {!isEmpty(isAuthenticated) && (
                    <>
                        {userRole === 'consumer' && (
                            <Route path={`/consumer/*`} element={<ConsumerTheme openNotificationWithIcon={openNotificationWithIcon} />} />
                        )}

                        <Route
                            path={`/${routes.mainRoute}/*`}
                            element={<Theme blue10={''} openNotificationWithIcon={openNotificationWithIcon} />}
                        />
                    </>
                )}
                <Route path="*" element={<NotFound />} />
            </Routes>
            <OfflineUI isOnline={isOnline} />
            <AppUpdatePrompt />
        </>
    );
};

export default App;
